export interface Model {
  id: string;
  model_name: string;
  version: string;
  provider: string;
  description: string;
  type: string;
  size: string;
  status: string;
  icon: string;
  iconBg: string;
  featured?: boolean;
}

export const modelsData: any = {
  models: [
    {
      id: "1",
      model_name: "GPT-4 Turbo",
      version: "gpt-4-turbo-2024-04-09",
      provider: "OpenAI",
      description: "Most capable GPT-4 model with improved instruction following, JSON mode, and reproducible outputs. Optimized for chat and traditional completions.",
      type: "LLM",
      size: "Large",
      status: "deployed",
      icon: "🤖",
      iconBg: "bg-gradient-to-br from-green-400 to-emerald-500",
      featured: true
    },
    {
      id: "2",
      model_name: "Claude 3 Opus",
      version: "claude-3-opus-20240229",
      provider: "Anthropic",
      description: "Most intelligent Claude model for highly complex tasks. Top-level performance, intelligence, fluency, and understanding.",
      type: "LLM",
      size: "Large",
      status: "ready",
      icon: "🟣",
      iconBg: "bg-gradient-to-br from-purple-400 to-violet-500",
      featured: true
    },
    {
      id: "3",
      model_name: "Gemini Pro",
      version: "gemini-pro-1.5",
      provider: "Google",
      description: "Best model for scaling across a wide range of tasks. Enhanced with multimodal capabilities and long context understanding.",
      type: "LLM",
      size: "Large",
      status: "ready",
      icon: "🔴",
      iconBg: "bg-gradient-to-br from-red-400 to-pink-500",
      featured: false
    },
    {
      id: "4",
      model_name: "GPT-3.5 Turbo",
      version: "gpt-3.5-turbo-0125",
      provider: "OpenAI",
      description: "Fast and efficient model for straightforward tasks. Great balance between capability and cost.",
      type: "LLM",
      size: "Medium",
      status: "deployed",
      icon: "🔷",
      iconBg: "bg-gradient-to-br from-blue-400 to-cyan-500",
      featured: false
    },
    {
      id: "5",
      model_name: "Claude 3 Sonnet",
      version: "claude-3-sonnet-20240229",
      provider: "Anthropic",
      description: "Balanced model for most workloads. Ideal combination of performance and speed for enterprise applications.",
      type: "LLM",
      size: "Medium",
      status: "ready",
      icon: "🔵",
      iconBg: "bg-gradient-to-br from-indigo-400 to-blue-500",
      featured: false
    },
    {
      id: "6",
      model_name: "Llama 3 70B",
      version: "llama-3-70b-instruct",
      provider: "Meta",
      description: "Open-source large language model with excellent performance. Strong reasoning and coding capabilities.",
      type: "LLM",
      size: "Large",
      status: "ready",
      icon: "🦙",
      iconBg: "bg-gradient-to-br from-orange-400 to-amber-500",
      featured: true
    },
    {
      id: "7",
      model_name: "Mistral Large",
      version: "mistral-large-latest",
      provider: "Mistral AI",
      description: "Cutting-edge model with top-tier reasoning capabilities. Excellent for complex tasks requiring deep understanding.",
      type: "LLM",
      size: "Large",
      status: "draft",
      icon: "🌟",
      iconBg: "bg-gradient-to-br from-yellow-400 to-orange-500",
      featured: false
    },
    {
      id: "8",
      model_name: "GPT-4 Vision",
      version: "gpt-4-vision-preview",
      provider: "OpenAI",
      description: "Advanced vision capabilities with GPT-4 intelligence. Understands images and provides detailed analysis.",
      type: "Vision",
      size: "Large",
      status: "ready",
      icon: "💎",
      iconBg: "bg-gradient-to-br from-teal-400 to-cyan-500",
      featured: false
    }
  ] as Model[]
};

export default modelsData;
